import classNames from "classnames";
import moment from "moment";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers/index.js";
import { Typography } from "PFComponents/typography/index.js";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useTranslation } from "react-i18next";

import css from "./footer.module.scss";

type FooterProps = {
  startDate: string | null;
  endDate: string | null;
  onReset: () => void;
  isRegularText: boolean;
  maxDaysLength?: number;
};

export const Footer = ({ startDate, endDate, onReset, isRegularText, maxDaysLength }: FooterProps) => {
  const { t } = useTranslation();
  const { formatDate } = useDateFormatter();

  if (!startDate) {
    return null;
  }

  return (
    <Stack center gap="spacingSm">
      <span
        className={classNames(css.footer, {
          [css.smallText]: !isRegularText
        })}
      >
        {!!endDate && (
          <>{startDate === endDate ? startDate : `${formatDate(startDate)} - ${formatDate(endDate)}`}</>
        )}
        {!endDate && (
          <>
            {t("selectEndDate", { date: formatDate(startDate) })}
            <Button kind="blank" title={t("resetDates")} onClick={onReset}>
              &times;
            </Button>
          </>
        )}
      </span>
      {!!maxDaysLength && (
        <Typography variant={"labelRegular"} className={css.durationInfo}>
          {t("maxCalendarPeriodLength", { duration: moment.duration(maxDaysLength, "days").humanize() })}
        </Typography>
      )}
    </Stack>
  );
};
